import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { verify } from '../jwtSupplier/Jwt';

const SupplierGuard = ({ children }) => {
    const navigate = useNavigate();
    
    useEffect(() => {
        try {
            const token = localStorage.getItem('supplierToken');
            console.log('Checking supplier token:', token);

            if (!token) {
                console.log('No token found');
                const currentPath = window.location.pathname;
                localStorage.setItem('supplierRedirectUrl', currentPath);
                navigate('/supplier/check');
                return;
            }

            const isValid = verify(token);
            console.log('Token validation result:', isValid);

            if (!isValid) {
                console.log('Invalid or expired token');
                localStorage.removeItem('supplierToken');
                const currentPath = window.location.pathname;
                localStorage.setItem('supplierRedirectUrl', currentPath);
                navigate('/supplier/check');
            }
        } catch (error) {
            console.error('Guard error:', error);
            localStorage.removeItem('supplierToken');
            navigate('/supplier/check');
        }
    }, [navigate]);

    return children;
};

export default SupplierGuard; 